@let finderIsOpen = fileMgmtFeature.selectors.finderIsOpen.asSignal();

@if (finderIsOpen) {
  @let fileTree = fileMgmtFeature.selectors.fileTree.asSignal();
  @let isLoadingFiles =
    fileMgmtFeature.selectors.isFinderFilesLoading.asSignal();
  @let fileRetrievalError =
    fileMgmtFeature.selectors.finderFilesError.asSignal();

  <atn-ds-attached-overlay
    [origin]="originSg()"
    [offsetX]="navbarStore.widthSg() ?? 0"
    [offsetY]="180"
    (backdropClick)="
      fileMgmtFeature.actions.displayFinder
        .from('FileFinder.Overlay.Backdrop.Clicked')
        .dispatch(false)
    "
  >
    <div class="atn-file-finder">
      <div class="atn-file-finder__file-list">
        @if (isLoadingFiles) {
          <div class="atn-file-finder__status">Loading files…</div>
        } @else if (fileRetrievalError) {
          <div class="atn-file-finder__status">
            Unable to load files. Please try again.
          </div>
        } @else {
          @for (group of fileTree.groups; track group.id; let isLast = $last) {
            <atn-file-finder-group
              [group]="group"
              [isLast]="isLast"
            />
          } @empty {
            <div class="atn-file-finder__status">No files in this zone.</div>
          }
        }
      </div>
    </div>
  </atn-ds-attached-overlay>
}
